"use strict";

import React from 'react';
import useAddressSuggestion from "../hook/useAddressSuggestion";
import FormAutoSuggest from "./FormAutoSuggest";

const FormAddressInputAutoSuggest = ({inputValue='', inputName='address', inputPlaceHolder='',
                                     onInputChange=()=>{}, onInputBlur=()=>{},getFocusedSuggestionValue=()=>{},
                                     onSuggestionSelected=()=>{},}) => {
    const {setValue:setSuggestionRequestValue, status:suggestionStatus, data:suggestions, clearSuggestions,} = useAddressSuggestion();
    return (
        <FormAutoSuggest
            inputValue={inputValue}
            inputName={inputName}
            onInputChange={onInputChange}
            onInputBlur={onInputBlur}
            placeholder={inputPlaceHolder}
            suggestions={suggestions}
            setSuggestionRequestValue={setSuggestionRequestValue}
            clearSuggestions={clearSuggestions}
            getFocusedSuggestionValue={(suggestion)=>{
                const {structured_formatting: {main_text=''}} = suggestion;
                getFocusedSuggestionValue(suggestion);
                return main_text;
            }}
            onSuggestionSelected={onSuggestionSelected}
            renderSuggestion={(suggestion)=>{
                const {place_id, description, structured_formatting: { main_text, secondary_text }} = suggestion;
                if(suggestionStatus === "OK"){
                    return (
                        <span><strong>{main_text}</strong> <small>{secondary_text}</small></span>
                    );
                }
                return null;
            }} />
    );
};

export default FormAddressInputAutoSuggest;
